"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.huCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var huCountry = exports.huCountry = function huCountry(t) {
  return {
    id: 'HU',
    name: t('Hungary'),
    flag: '🇭🇺',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1051 or 6720',
    phonePrefix: '36',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Budapest',
    currency: 'EUR'
  };
};